module.exports = __webpack_public_path__ + "static/media/urbangoo16.4479279f.webp";